import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TermsModal from '@/Components/common/Modals/TermsModal.js';
import { userService } from '../services/auth/userService.js';
import yn from 'yn';
import { getTenantId, loadTenantConfig } from '@/services/tenant/tenantService.js';

const TermsContext = createContext();

const TERMS_SESSION_KEY = 'termsSkippedDueToError';

/** CMS e alguns JSONs usam REACT_APP_SHOW_TERMS_AND_CONDITIONS; o código histórico usa SHOW_TERMS_AND_CONDITIONS. */
const isShowTermsFeatureEnabled = (featureFlags) =>
  yn(featureFlags?.SHOW_TERMS_AND_CONDITIONS) ||
  yn(featureFlags?.REACT_APP_SHOW_TERMS_AND_CONDITIONS);

export const useTerms = () => {
  const context = useContext(TermsContext);
  if (!context) {
    throw new Error('useTerms must be used within a TermsProvider');
  }
  return context;
};

export const TermsProvider = ({ children }) => {
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const location = useLocation();
  const tenantId = getTenantId();

  useEffect(() => {
    const fetchConfigAndDecideTerms = async () => {
      try {
        const config = await loadTenantConfig();
        const accepted = yn(localStorage.getItem('termsAccepted')) === true;
        const skippedThisSession = sessionStorage.getItem(TERMS_SESSION_KEY) === 'true';
        const isTourGuide = location?.pathname === '/tour-guide';
        const isAuthenticated = userService.isAuthenticated();

        setTermsAccepted(accepted);

        const shouldShowTerms = !accepted && !skippedThisSession && (
          isShowTermsFeatureEnabled(config.FEATURE_FLAGS) &&
          yn(isAuthenticated) && !isTourGuide
        );
  
        setShowTerms(shouldShowTerms);

      } catch (error) {
        console.error('Error fetching config or evaluating terms:', error);
        setShowTerms(false);
      }
    };
  
    fetchConfigAndDecideTerms();
  }, [tenantId, location]);
  

  const handleAcceptTerms = () => {
    try {
      localStorage.setItem('termsAccepted', 'true');
      setTermsAccepted(true);
      setShowTerms(false);
    } catch (error) {
      console.error('Error accepting terms:', error);
    }
  };

  const handleSkipTermsDueToError = () => {
    sessionStorage.setItem(TERMS_SESSION_KEY, 'true');
    setShowTerms(false);
  };

  return (
    <TermsContext.Provider value={{ showTerms, termsAccepted, handleAcceptTerms }}>
      {children}
      {(showTerms && userService.isAuthenticated()) && (
        <TermsModal onAccept={handleAcceptTerms} onSkip={handleSkipTermsDueToError} />
      )}
    </TermsContext.Provider>
  );
}; 
